import { colors } from '../../lib/theme';

export function ToggleRow({
  label,
  sub,
  value,
  onChange,
}: {
  label: string;
  sub: string;
  value: boolean;
  onChange: () => void;
}) {
  return (
    <div
      className="flex items-start justify-between gap-3 rounded-xl px-3.5 py-3 transition-colors"
      style={{
        border: `1px solid ${value ? `${colors.greenDim}47` : colors.border}`,
        backgroundColor: colors.bgTertiary,
      }}
    >
      <div>
        <div className="text-[13.5px] font-semibold" style={{ color: colors.textPrimary }}>
          {label}
        </div>
        <div className="mt-0.5 text-[11.5px] leading-snug" style={{ color: colors.textMuted }}>
          {sub}
        </div>
      </div>
      <button
        type="button"
        onClick={onChange}
        className="relative h-6 w-11 shrink-0 rounded-full transition-all duration-200"
        style={{
          backgroundColor: value ? colors.green : colors.border,
        }}
        aria-pressed={value}
        aria-label={`Toggle ${label}`}
      >
        <span
          className={`absolute top-0.5 left-0.5 inline-block h-5 w-5 rounded-full bg-white transition-all duration-200 ${value ? 'translate-x-5' : 'translate-x-0'}`}
        />
      </button>
    </div>
  );
}
